<template>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>LearnLanguage.Today</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field v-model="username" prepend-icon="person" name="login" label="Login" type="text" :disabled="disabled"></v-text-field>
              <v-text-field v-model="password" prepend-icon="lock" name="password" label="Password" type="password" :disabled="disabled"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="disabled" v-on:click="login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Api from '../common/api'
import { SET_AUTH } from '../store/mutation-types'
import { LOAD_COMMON_DATA } from '../store/action-types'

export default {
  data () {
    return {
      username: null,
      password: null,
      disabled: false
    }
  },
  methods: {
    async login () {
      if (this.disabled) {
        return
      }
      this.disabled = true

      Api.setAuth(this.username, this.password)
      try {
        const result = await Api.checkLogin()
        if (result) {
          this.$store.commit(SET_AUTH)
          await this.$store.dispatch(LOAD_COMMON_DATA)
          if (this.$route.query.target) {
            this.$router.push({ path: this.$route.query.target })
          } else {
            this.$router.push('base-words')
          }
        } else {
          alert('Неправильный логин или пароль')
        }
      } finally {
        this.disabled = false
      }
    }
  }
}
</script>

<style scoped>

</style>
